import { useState } from 'react';
import { navBoards } from '@/mocks/haijiao';

const anchors = [
  { name: '热门板块', href: '#boards' },
  { name: '广场话题', href: '#feed' },
  { name: '内容分类', href: '#categories' },
  { name: '圈子精选', href: '#flow' },
  { name: '热度榜单', href: '#ranking' },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-stone-200/80 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-14 max-w-[1240px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-600 text-white">
            <i className="ri-sun-line text-lg"></i>
          </span>
          <span className="whitespace-nowrap text-lg font-bold tracking-tight text-stone-900">海角社区</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {anchors.map((n) => (
            <a
              key={n.name}
              href={n.href}
              className="whitespace-nowrap rounded-full px-3 py-2 text-sm text-stone-600 transition-colors hover:bg-orange-50 hover:text-orange-700"
            >
              {n.name}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <div className="flex items-center gap-2 rounded-full border border-stone-200 bg-orange-50/60 px-3 py-1.5 text-sm text-stone-500">
            <i className="ri-search-line text-orange-600"></i>
            <span className="whitespace-nowrap">搜搜大家都在聊什么</span>
          </div>
          <a
            href="#download"
            className="whitespace-nowrap rounded-full bg-orange-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-orange-700"
          >
            下载客户端
          </a>
        </div>

        <button
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-stone-700 md:hidden"
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-stone-200 bg-white px-4 py-3 md:hidden">
          <div className="flex flex-wrap gap-2">
            {navBoards.map((n) => (
              <a
                key={n.name}
                href="#boards"
                onClick={() => setOpen(false)}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-orange-50 px-3 py-1.5 text-sm text-stone-700"
              >
                <i className={`${n.icon} text-orange-600`}></i>
                {n.name}
              </a>
            ))}
          </div>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-full bg-orange-600 px-4 py-2 text-center text-sm font-medium text-white"
          >
            下载客户端
          </a>
        </div>
      )}
    </header>
  );
}